const SCORE_KEY = "yoga_score";
const TIME_KEY = "yoga_time_sec";
const ANSWERS_KEY = "yoga_matched_names";

function persistKey() {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    const user = JSON.parse(raw);
    if (!user?.userId || !user?.sessionId) return null;
    return `yoga_session_${user.sessionId}_${user.userId}`;
  } catch {
    return null;
  }
}

function readFromStorage(storage) {
  try {
    const score = Number.parseInt(storage.getItem(SCORE_KEY) ?? "0", 10) || 0;
    const timeSec = Number.parseInt(storage.getItem(TIME_KEY) ?? "0", 10) || 0;
    const raw = storage.getItem(ANSWERS_KEY);
    let matchedNames = [];
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) matchedNames = parsed;
    }
    return { score, timeSec, matchedNames };
  } catch {
    return { score: 0, timeSec: 0, matchedNames: [] };
  }
}

function writeToStorage(storage, { score, timeSec, matchedNames }) {
  storage.setItem(SCORE_KEY, String(score ?? 0));
  storage.setItem(TIME_KEY, String(timeSec ?? 0));
  if (Array.isArray(matchedNames)) {
    storage.setItem(ANSWERS_KEY, JSON.stringify(matchedNames));
  }
}

export function saveTalentSession({ score, timeSec, matchedNames }) {
  const payload = {
    score: score ?? 0,
    timeSec: timeSec ?? 0,
    matchedNames: Array.isArray(matchedNames) ? matchedNames : [],
  };
  try {
    writeToStorage(sessionStorage, payload);
  } catch {
    /* ignore */
  }
  const key = persistKey();
  if (!key) return;
  try {
    localStorage.setItem(key, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function readTalentSession() {
  const fromSession = readFromStorage(sessionStorage);

  let fromLocal = { score: 0, timeSec: 0, matchedNames: [] };
  const key = persistKey();
  if (key) {
    try {
      const raw = localStorage.getItem(key);
      if (raw) {
        const parsed = JSON.parse(raw);
        fromLocal = {
          score: Number.parseInt(String(parsed?.score ?? "0"), 10) || 0,
          timeSec: Number.parseInt(String(parsed?.timeSec ?? "0"), 10) || 0,
          matchedNames: Array.isArray(parsed?.matchedNames) ? parsed.matchedNames : [],
        };
      }
    } catch {
      /* ignore */
    }
  }

  return {
    score: Math.max(fromSession.score, fromLocal.score),
    timeSec: Math.max(fromSession.timeSec, fromLocal.timeSec),
    matchedNames: fromSession.matchedNames.length
      ? fromSession.matchedNames
      : fromLocal.matchedNames,
  };
}

export function appendTalentAnswer(name) {
  const { score, timeSec, matchedNames } = readTalentSession();
  const next = [...matchedNames, String(name || "").trim()].filter(Boolean);
  saveTalentSession({ score, timeSec, matchedNames: next });
  return next;
}
